import { Button } from "components/ui";
import InputModern from "components/ui/Input/InputModern";
import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useState } from "react";
import { HiOutlineCpuChip } from "react-icons/hi2";
import useMagicAction, { RESULT_SCHEMA, asText } from "./useMagicAction";

const AskAIToWrite = ({ inputRef, ...props }) => {

    const [ placeholder, setPlaceholder ] = useState("");
    const [ about, setAbout ] = useState("");
    const { company } = useContext(CompanyContext);
    const { isLoading, run, writeBackInsert, closeMenu } = useMagicAction(props);

    const placeholderOptions = company?.interests;

    const handleOnClick = async () => {
        run({
            prompt: `Write a social post of about 280 characters about: ${about ? about : "something interesting and relevant to the company"}. Return only the post text.`,
            schema: RESULT_SCHEMA,
        })
            .then((r) => writeBackInsert(asText(r)))
            .finally(closeMenu);
    }

    useEffect(() => {
        setPlaceholder(placeholderOptions?.[Math.floor(Math.random() * placeholderOptions?.length)]);
    }, []);

    return (
        <div className="flex flex-col gap-2">
            <InputModern
                autoFocus
                textArea
                value={about}
                onChange={(e) => setAbout(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && (e.shiftKey || e.metaKey || e.ctrlKey)) {
                        e.preventDefault();
                        if (!isLoading) handleOnClick();
                    }
                }}
                placeholder={`Try "${placeholder}"`}
            />
            <div className="items-center w-full">
                <Button loading={isLoading} disabled={isLoading} onClick={handleOnClick} className="w-full" variant="solid" icon={<HiOutlineCpuChip />}>&nbsp; Generate</Button>
            </div>
        </div>
    )
}

export default AskAIToWrite;
